import { useMemo } from "react";
import PropTypes from "prop-types";
import Toggle from "@shared/v2/Toggle";
import Dropdown from "@shared/v2/Dropdown/Dropdown";
import Avatar from "@shared/v2/Avatar";
import CircleInfoSolidV6 from "@shared/v2/Icomoon/Icons/CircleInfoSolidV6";
import Tooltip from "@shared/v2/Tooltip";

const formatOptionLabel = ({ label, avatarUrl }) => (
  <div className="tw-flex tw-flex-row tw-items-center tw-whitespace-nowrap">
    <Avatar className="tw-mr-8px" size="small" src={avatarUrl} alt={label} />
    <span className="tw-overflow-ellipsis tw-w-[90px] tw-font-normal">{label}</span>
  </div>
);

const TextMessagingSettings = ({
  isEnabledInboundTexts,
  handleToggle,
  selectedTextInboundUser,
  textInboundUsers,
  setSelectedTextInboundUsers,
}) => {
  const userOptions = useMemo(() => {
    return textInboundUsers.toSorted((a, b) => (a.label > b.label ? 1 : -1));
  }, [textInboundUsers]);

  return (
    <div className="tw-flex tw-flex-col tw-gap-8px">
      <span className="tw-text-18px tw-text-gray-75 tw-font-normal">Text Messaging Settings</span>
      <div className="tw-pb-[8px] tw-pt-[16px]">
        <Toggle
          id="text-messaging"
          name="text-messaging"
          trackClassName="!tw-w-[28px] !tw-h-[16px]"
          dotClassName="!tw-w-[12px] !tw-h-[12px] !tw-left-[2px]"
          value={isEnabledInboundTexts}
          checked={isEnabledInboundTexts}
          onChange={handleToggle}
          text={
            <div className="tw-text-14px tw-text-gray-75 tw-font-normal">
              Enable inbound texts for this number.
            </div>
          }
          labelClassName="tw-text-[14px] !tw-text-gray-50 tw-font-semibold "
        />

        <div className="tw-ml-[36px] tw-text-12px tw-text-gray-50 tw-font-normal">
          Please note: you won't be able to reply from this number. All responses will come from your Brivity
          number instead. Inbound texts will create a new contact if none exists. Text notifications will not
          follow call routing rules.
        </div>
      </div>
      {isEnabledInboundTexts && (
        <div className="tw-flex tw-flex-col tw-gap-8px ">
          <Dropdown
            label={
              <>
                Send texts to
                <Tooltip
                  className="tw-ml-[5px]"
                  placement="top"
                  trigger={<CircleInfoSolidV6 className="tw-text-gray-75" size="m" />}
                  content="Text-in leads will be assigned to this admin user."
                />
              </>
            }
            placeholder="Select"
            value={selectedTextInboundUser}
            options={userOptions}
            onChange={(e) => setSelectedTextInboundUsers(e)}
            formatOptionLabel={formatOptionLabel}
            menuShouldComeToFront
          />
        </div>
      )}
    </div>
  );
};

TextMessagingSettings.propTypes = {
  handleToggle: PropTypes.func,
  isEnabledInboundTexts: PropTypes.bool,
  selectedTextInboundUser: PropTypes.shape({}).isRequired,
  textInboundUsers: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  setSelectedTextInboundUsers: PropTypes.func.isRequired,
};
TextMessagingSettings.defaultProps = {
  handleToggle: () => {},
  isEnabledInboundTexts: false,
};
export default TextMessagingSettings;
